import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtnaExtendedFabModule, MtnaFieldSetModule, MtnaPopoverModule, MtnaSelectSearchModule } from '@mtna/core-angular';

import { RdsArraySomePipeModule } from '../core/pipes/array-some.pipe';
import { RdsIsClassifiedPipeModule } from '../core/pipes/is-classified.pipe';
import { RdsIsDimensionPipeModule } from '../core/pipes/is-dimension.pipe';
import { RdsFilterModule } from '../filter/index';
import { RdsMeasureSelectModule } from '../measure-select/index';
import { RdsTabulationDisplayOptionsModule } from '../tabulation-display-options/index';
import { RdsTabulationSortOptionsModule } from '../tabulation-sort-options/index';
import { RdsTabulationTotalsOptionsModule } from '../tabulation-totals-options/index';
import { RdsVariableSelectModule } from '../variable-select/index';
import { RdsDimensionSelectionComponent } from './dimension-selection.component';

const COMPONENTS = [RdsDimensionSelectionComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    MtnaExtendedFabModule,
    MtnaFieldSetModule,
    MtnaPopoverModule,
    MtnaSelectSearchModule,
    RdsArraySomePipeModule,
    RdsFilterModule,
    RdsIsClassifiedPipeModule,
    RdsIsDimensionPipeModule,
    RdsMeasureSelectModule,
    RdsTabulationDisplayOptionsModule,
    RdsTabulationSortOptionsModule,
    RdsTabulationTotalsOptionsModule,
    RdsVariableSelectModule,
    ReactiveFormsModule,
    ScrollingModule,
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS],
})
export class RdsDimensionSelectionModule {}

export * from './dimension-selection.component';
